import './idroflog.css';
import laluvit_img from '../../assets/laluvit.png';
import { GoDotFill } from 'react-icons/go';
import { useTranslation, Trans } from 'react-i18next';

const Laluvit = () => {
  const { t } = useTranslation('global');
  return (
    <section className="product-hero" aria-labelledby="laluvit-title">
      <div className="product-hero__copy">
        <p className="product-hero__kicker">BeoMedica</p>
        <h1 id="laluvit-title">{t('laluvit.title')}</h1>
        <h2 className="product-hero__subtitle">{t('laluvit.sub_title')}</h2>
        <p className="product-hero__subtitle-2">
          <Trans
            ns="global"
            i18nKey="laluvit.sub_title_2"
            components={{ red: <span style={{ color: '#c0392b' }} /> }}
          />
        </p>
        <p>{t('laluvit.paragraph_1')}</p>
        <ul className="product-hero__list">
          <li>
            <GoDotFill aria-hidden="true" />
            {t('laluvit.list_item_1')}
          </li>
          <li>
            <GoDotFill aria-hidden="true" />
            {t('laluvit.list_item_2')}
          </li>
          <li>
            <GoDotFill aria-hidden="true" />
            {t('laluvit.list_item_3')}
          </li>
        </ul>
        <p>{t('laluvit.paragraph_2')}</p>
      </div>
      <div className="product-hero__media">
        <img src={laluvit_img} alt={t('laluvit.title')} />
      </div>
    </section>
  );
};

export default Laluvit;
